import { render } from "./FaqEditItem.vue?vue&type=template&id=0f63b84d"
import script from "./FaqEditItem.vue?vue&type=script&lang=js"
export * from "./FaqEditItem.vue?vue&type=script&lang=js"
script.render = render

export default script

/* vue-cli-plugin-import-components */
import BaseInput from "@/components/BaseInput.vue";
import BaseTextArea from "@/components/BaseTextArea.vue";
import RenderMarkdown from "@/components/RenderMarkdown.vue";
import BaseButton from "@/components/BaseButton.vue";
import BaseConfirmModal from "@/components/BaseConfirmModal.vue";
import FaqEditItemInstructions from "@/components/FaqEditItemInstructions.vue";
script.components = Object.assign({}, { BaseInput, BaseTextArea, RenderMarkdown, BaseButton, BaseConfirmModal, FaqEditItemInstructions }, script.components);